/**
 * Perfiles de la app de conductores (Anexo A del plan, 2026-10-05).
 * Una misma persona puede entrar como conductor o como administrador de vehículos (solo lectura de los
 * traslados de sus vehículos). El perfil activo es el "role" del usuario guardado.
 */
export const PERFIL_CONDUCTOR = "conductor";
export const PERFIL_ADMINISTRADOR = "admin_vehiculo";

export const usuarioGuardado = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch (e) {
    return null;
  }
};

export const esAdministrador = (user = usuarioGuardado()) =>
  user?.role === PERFIL_ADMINISTRADOR;

/** Rutas de la API según el perfil activo */
export const rutaRenovacion = (user = usuarioGuardado()) =>
  esAdministrador(user) ? "/admin-vehiculo/refresh-token" : "/conductor/refresh-token";

export const rutaTraslados = (user = usuarioGuardado()) =>
  esAdministrador(user) ? "/admin-vehiculo/traslados" : "/traslados/mis-traslados";

export const rutaDetalleTraslado = (id, user = usuarioGuardado()) =>
  esAdministrador(user) ? `/admin-vehiculo/traslado/${id}` : `/conductor/traslado/${id}`;

export const rutaCambioContrasena = (user = usuarioGuardado()) =>
  esAdministrador(user) ? "/admin-vehiculo/cambiar-password" : "/conductor/cambiar-contrasena";

/** Otros perfiles a los que la persona puede cambiar desde el menú lateral */
export const otrosPerfiles = (user = usuarioGuardado()) =>
  (user?.perfiles || []).filter((p) => p.perfil !== (user?.role || PERFIL_CONDUCTOR));
